import type { QueryKey } from "@tanstack/react-query";

export const isSameQueryKey = (queryKey1: QueryKey, queryKey2: QueryKey) => {
  return queryKey1.length === queryKey2.length && queryKey1.every((value, index) => value === queryKey2[index]);
};
